<template>

    <!-- <div v-if="status?.date && !itemLabel"> -->
    <div v-if="status?.date">
        <q-item-label caption v-if="!$_.isArray(status.date)" class="relative-positio">
<!-- {{log('ONE',status)}} -->
            <span :class="(dense || $_isMobile) ? 'text-sm' : ''">
                <span v-if="prefixed">le </span>{{ formatDate({datetime: status.date, withHour: true}) }}&nbsp;(s{{status.week}})
            </span>
            <Popup v-if="status.comment" no-zoo size="xs" icon="copyright" color="grey" padding="none" dense btn-class="bsolute-top-left q-ml--l">{{ status.comment }}</Popup>
        </q-item-label>

        <q-item-label caption v-else v-for="(date, skey, k) in status.date" :key="k" class="relative-positio">
<!-- {{log('MANY',status)}} -->
            <span :class="(dense || $_isMobile) ? 'text-sm' : ''">
                <span v-if="prefixed">le </span>{{ formatDate({datetime: date, withHour: true}) }}&nbsp;(s{{status.week?.[skey]}})
            </span>
            <Popup v-if="($_.isArray(status.comment) && status.comment[skey])" no-zoo size="xs" icon="copyright" color="grey" padding="none" dense btn-class="bsolute-top-left q-ml--l">{{ status.comment[skey] }}</Popup>
            <Popup v-else-if="( ! $_.isArray(status.comment) && status.comment)" no-zoo size="xs" icon="copyright" color="grey" padding="none" dense btn-class="bsolute-top-left q-ml--l">{{ status.comment }}</Popup>
        </q-item-label>
    </div>

</template>

<script setup>
import { formatDate } from "@helpers";

const props = defineProps({
    status: Object,
    prefixed: Boolean, // juste pour affichier ou non  'le '
    // 'item-label': Boolean, // pour mettre dans un 'q-item-section'
    dense: Boolean
})

</script>
